import { render } from "./DictionaryColorDetail.vue?vue&type=template&id=5ff08c6c"
import script from "./DictionaryColorDetail.vue?vue&type=script&lang=js"
export * from "./DictionaryColorDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__